var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSiSlovenia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_23111)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.127 0H-25.873V45H64.127V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.127 29.9971H-25.873V45H64.127V29.9971Z",
    fill: "#D50000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.127 15.0029H-25.873V29.9971H64.127V15.0029Z",
    fill: "#0000BF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6035 8.17383C38.9551 13.5879 39.166 16.5586 39.9834 17.9297C40.8799 19.4062 41.7412 20.4873 45.2305 21.7969C48.7109 20.4873 49.5723 19.4062 50.4687 17.9297C51.2949 16.5586 51.4971 13.5879 51.8486 8.17383L51.3389 7.99805C50.3018 7.68164 49.5283 7.42676 48.957 7.3125C48.1396 7.13672 47.4365 6.94336 45.2393 6.89941C43.042 6.93457 42.3389 7.14551 41.5215 7.32129C40.959 7.44434 40.1504 7.67285 39.1221 7.99805L38.6035 8.17383Z",
    fill: "#D50000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1133 7.99805C39.4473 13.4033 39.7285 15.8818 40.168 17.0684C41.0117 19.1074 42.3477 20.2236 45.2305 21.2871C48.1133 20.2236 49.4492 19.1074 50.3018 17.0684C50.7412 15.873 51.0049 13.4033 51.3389 7.98926C50.3193 7.67285 49.5283 7.42676 48.957 7.3125C48.1396 7.13672 47.4365 6.93457 45.2393 6.89941C43.042 6.93457 42.3389 7.13672 41.5215 7.3125C40.7079 7.4977 39.9042 7.72357 39.1133 7.98926V7.99805Z",
    fill: "#0000BF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2305 9.65039L45.0986 9.97559L44.4834 10.0635L44.8789 10.3008L44.501 10.5557L45.0547 10.6436L45.2305 10.9424L45.4063 10.6348L45.9336 10.5645L45.582 10.3008L45.9512 10.0635L45.3623 9.97559L45.2305 9.65039Z",
    fill: "#FFDF00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3701 15.7852L40.7129 15.5215L40.9502 15.1172L41.4248 14.7041L41.6797 14.291L42.1543 13.8604L42.3828 13.4473L42.6465 13.2451L42.8047 13.0781L43.2441 13.4561L43.4727 13.8691L43.7627 14.1328L44.0879 13.8779L44.3252 13.4561L45.2305 11.8477L46.1357 13.4561L46.373 13.8779L46.6982 14.1328L46.9883 13.8691L47.2256 13.4561L47.6562 13.0781L47.8232 13.2363L48.0781 13.4473L48.3066 13.8604L48.7812 14.291L49.0361 14.7041L49.5107 15.1172L49.748 15.5215L50.0908 15.7852C49.8976 16.9949 49.3252 18.1121 48.4561 18.9756C47.5132 19.7825 46.4199 20.3949 45.2393 20.7773C44.0496 20.4034 42.949 19.7903 42.0049 18.9756C41.4951 18.4482 40.5459 17.2793 40.3701 15.7852Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.7891 7.37402L43.6484 7.69922L43.0332 7.78711L43.4375 8.02441L43.0508 8.2793L43.6045 8.36719L43.7803 8.66602L43.9561 8.3584L44.4834 8.28809L44.1318 8.02441L44.501 7.78711L43.9209 7.69922L43.7803 7.37402H43.7891ZM46.6895 7.37402L46.5488 7.69922L45.9336 7.77832L46.3291 8.01562L45.9512 8.27051L46.5049 8.3584L46.6807 8.65723L46.8564 8.3584L47.3838 8.2793L47.0322 8.01562L47.4014 7.77832L46.8125 7.69043L46.6807 7.36523L46.6895 7.37402Z",
    fill: "#FFDF00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.126 17.8418H41.7764L42.3916 17.7979L43.1211 17.4463H43.9473L44.6592 17.7979L45.2305 17.8506L45.793 17.7979L46.5049 17.4463H47.3398L48.0781 17.7979L48.6846 17.8506L49.3525 17.8418L49.6689 17.2969L49.6602 17.2793L48.6758 17.4463L48.0693 17.4023L47.3398 17.042H46.5137L45.793 17.3936L45.2305 17.4463L44.6592 17.3936L43.9473 17.042H43.1211L42.3828 17.3936L41.7764 17.4463L40.8271 17.2705L40.8096 17.3057L41.1348 17.8418H41.126ZM48.7197 18.6768L48.0693 18.6328L47.3398 18.2813H46.5137L45.793 18.6328L45.2305 18.6768L44.668 18.6328L43.9473 18.2813H43.1211L42.3916 18.6328L41.7324 18.6768L41.3105 18.1494H41.3193L41.7764 18.2725L42.3828 18.2285L43.1123 17.877H43.9385L44.6592 18.2285L45.2217 18.2813L45.793 18.2285L46.5049 17.877H47.3398L48.0781 18.2285L48.6846 18.2813L49.124 18.167V18.1846L48.7285 18.6768H48.7197Z",
    fill: "#0000BF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_23111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiSlovenia);
export default __webpack_public_path__ + "static/media/si Slovenia.e53da28c9b1b6fc5a3b427a8fba6affb.svg";
export { ForwardRef as ReactComponent };